const initialState = {
    //customer notification list
    loadingCustomerNotificationList: false,
    CustomerNotificationListError: "",
    CustomerNotificationList: [],

}

const CustomerPanelReducer = (state = initialState, action) => {
    switch (action.type) {

        //customer notification list//
        case 'FIND_CUSTOMER_ALL_NOTIFICATIONS_REQUEST':
            return {
                ...state,
                loadingCustomerNotificationList: true,
                CustomerNotificationList: [],
                CustomerNotificationListError: '',
            };
        case 'FIND_CUSTOMER_ALL_NOTIFICATIONS_SUCCESS':
            return {
                ...state,
                loadingCustomerNotificationList: false,
                CustomerNotificationList: action.payload,
                CustomerNotificationListError: '',
            };
        case 'FIND_CUSTOMER_ALL_NOTIFICATIONS_FAILURE':
            return {
                ...state,
                loadingCustomerNotificationList: false,
                CustomerNotificationListError: action.payload,
                CustomerNotificationList: [],
            };
        //customer notification list//

        default:
            return state;
    }
}

export default CustomerPanelReducer;